import React from "react";

export default function Terms() {
  return (
    <section id="about" className="about">
      <div className="container aos-init aos-animate" data-aos="fade-up">

        <div className="section-title">
          <h2>Terms</h2>
          <p>Terms and condition:</p>
        </div>

        <div className="row">
          <div className="col-lg-12 order-1 order-lg-2 aos-init aos-animate" data-aos="fade-left" data-aos-delay="100">
          </div>
          <div className="col-lg-12 pt-4 pt-lg-0 order-2 order-lg-1 content">
            <ol type="1">
              <li>Once any package is purchased, no refund is allowed. Our package
gives access to corresponding packages for complete one year.</li>
              <li>Packages include <b>test series, recorded sessions, note & doubt
sessions.</b> We won’t ask for other charges to students.</li>
              <li>Students enrolling in any complete packages, will benefits with
additional feature under tab “ARA Exclusive” which will have
creativity videos, knowledgeable contents & most important
<b>interviews of successful people.</b></li>
              <li>No discounts will be offered since this is most affordable price for
              one year which include everything because we value your parents
money.</li>
              <li>In case of any doubts, students are advised to mail us. Response
will be given within 24 hours.</li>
              <li>No reproduction of any videos or content is allowed, otherwise it
              will be illegal & we have right to take strict action against anyone
finds guilty. (No recording, no editing)</li>
              <li>Use of any abusive language against any teacher will be strictly
              punishable offence. In case student finds problem with teachers,
              has right to mail to us. Mails are read by admin panels so your
feedback is confidential.</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}